module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/xy.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fxy.jpg
// module id = 8ECC
// module chunks = 93